var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49,27.954v-6l-7.141-1.167  c-0.423-1.691-1.087-3.281-1.962-4.737l4.162-5.932l-4.243-4.241l-5.856,4.21c-1.46-0.884-3.06-1.558-4.763-1.982l-1.245-7.106h-6  l-1.156,7.083c-1.704,0.418-3.313,1.083-4.777,1.963L10.18,5.873l-4.243,4.241l4.107,5.874c-0.888,1.47-1.563,3.077-1.992,4.792  L1,21.954v6l7.044,1.249c0.425,1.711,1.101,3.318,1.992,4.79l-4.163,5.823l4.241,4.245l5.881-4.119  c1.468,0.882,3.073,1.552,4.777,1.973l1.18,7.087h6l1.261-7.105c1.695-0.43,3.297-1.105,4.751-1.99l5.922,4.155l4.242-4.245  l-4.227-5.87c0.875-1.456,1.539-3.048,1.958-4.739L49,27.954z M25,33c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S29.418,33,25,33  z",
    className: "stroke",
    fill: "none",
    stroke: "#5E5E5E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.c778203d8eec8e6146ca1a267586379a.svg";
export { ForwardRef as ReactComponent };